(function () {
  function getData() {
    const pid = window.__bgThumbFilterCurrentProductId;
    if (!pid || !window.__bgThumbFilter) return null;
    return window.__bgThumbFilter[String(pid)] || window.__bgThumbFilter[pid] || null;
  }

  function getVariantId(variantIdToKey) {
    const inputs = Array.from(document.querySelectorAll('input[name="id"]'));
    for (const el of inputs) {
      const val = Number(el.value);
      if (Number.isFinite(val) && variantIdToKey[String(val)]) return val;
    }

    const fromUrl = Number(new URLSearchParams(location.search).get('variant'));
    if (Number.isFinite(fromUrl) && variantIdToKey[String(fromUrl)]) return fromUrl;

    return null;
  }

  function getThumbSlides() {
    const imgs = Array.from(document.querySelectorAll('img.product-medias__thumbnail__image[data-image-id]'));
    const slides = imgs.map(img => img.closest('.swiper-slide')).filter(Boolean);

    slides.forEach((slide, idx) => {
      if (!slide.dataset.mediaPos) slide.dataset.mediaPos = String(idx + 1);
    });

    return slides;
  }

  function refreshSwiperFromSlide(anySlide) {
    if (!anySlide) return;
    const swiperEl = anySlide.closest('.swiper');
    const swiper = swiperEl && swiperEl.swiper;
    if (swiper && typeof swiper.update === 'function') swiper.update();
  }

  function applyFilter() {
    const data = getData();
    if (!data) return;

    const { rangesByKey, variantIdToKey } = data;
    if (!rangesByKey || !variantIdToKey) return;

    const variantId = getVariantId(variantIdToKey);
    if (!variantId) return;

    const key = variantIdToKey[String(variantId)];
    if (!key) return;

    const range = rangesByKey[key];
    if (!range || range.start == null || range.end == null) return;

    const start = Number(range.start);
    const end = Number(range.end);

    const slides = getThumbSlides();
    if (!slides.length) return;

    let firstVisibleIndex = -1;

    slides.forEach((slide, idx) => {
      const pos = Number(slide.dataset.mediaPos);
      const inRange = pos >= start && pos <= end;
      slide.style.display = inRange ? '' : 'none';
      if (inRange && firstVisibleIndex === -1) firstVisibleIndex = idx;
    });

    refreshSwiperFromSlide(slides[0]);

    const swiperEl = slides[0].closest('.swiper');
    const swiper = swiperEl && swiperEl.swiper;
    if (swiper && typeof swiper.slideTo === 'function' && firstVisibleIndex >= 0) {
      swiper.slideTo(firstVisibleIndex, 0);
    }
  }

  function scheduleApply() {
    setTimeout(applyFilter, 0);
    setTimeout(applyFilter, 80);
    setTimeout(applyFilter, 250);
  }

  document.addEventListener('DOMContentLoaded', scheduleApply);
  document.addEventListener('change', scheduleApply);
  document.addEventListener('variant:change', scheduleApply);
})();